/* eslint-disable */ ! function(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define &&
    define.amd ? define([], t) : "object" == typeof exports ? exports.bwtHybrid = t() : e.bwtHybrid = t()
}(window, (function() {
  return function(e) {
    var t = {};

    function s(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, s), o.l = !0, o.exports
    }
    return s.m = e, s.c = t, s.d = function(e, t, n) {
      s.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      })
    }, s.r = function(e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      })
    }, s.t = function(e, t) {
      if (1 & t && (e = s(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (s.r(n), Object.defineProperty(n, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e)
        for (var o in e) s.d(n, o, function(t) {
          return e[t]
        }.bind(null, o));
      return n
    }, s.n = function(e) {
      var t = e && e.__esModule ? function() {
        return e.default
      } : function() {
        return e
      };
      return s.d(t, "a", t), t
    }, s.o = function(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t)
    }, s.p = "", s(s.s = 0)
  }([function(e, t, s) {
    e.exports = s(1)
  }, function(e, t, s) {
    "use strict";
    s.r(t);
    var n = {
      ERROR_TYPE_APIOS: {
        code: 1001,
        msg: "该API无法在当前OS下运行"
      },
      ERROR_TYPE_APIMODIFY: {
        code: 1002,
        msg: "不允许更改JSSDK的API"
      },
      ERROR_TYPE_MODULEMODIFY: {
        code: 1003,
        msg: "不允许更改JSSDK的模块"
      },
      ERROR_TYPE_APINOTEXIST: {
        code: 1004,
        msg: "调用了不存在的api"
      },
      ERROR_TYPE_PROTONOTEXIST: {
        code: 1005,
        msg: "调用错误，该组件api对应的proto不存在"
      },
      ERROR_TYPE_CUSTOMEAPINOTEXIST: {
        code: 1006,
        msg: "非容器下无法调用自定义组件API"
      },
      ERROR_TYPE_EVENTNOTEXIST: {
        code: 1007,
        msg: "对应的event事件在该环境下不存在"
      },
      ERROR_TYPE_INITVERSIONERROR: {
        code: 1008,
        msg: "初始化版本号错误，请检查容器api的实现情况"
      },
      ERROR_TYPE_READYMODIFY: {
        code: 2001,
        msg: "ready回调不允许多次设置"
      },
      ERROR_TYPE_CONFIGMODIFY: {
        code: 2002,
        msg: "config不允许多次调用"
      },
      ERROR_TYPE_CONFIGERROR: {
        code: 2003,
        msg: "config校验错误"
      },
      ERROR_TYPE_VERSIONNOTSUPPORT: {
        code: 2004,
        msg: "不支持当前容器版本，请确保容器与前端库版本匹配"
      },
      ERROR_TYPE_VERSIONNEEDUPGRADE: {
        code: 2005,
        msg: "当前JSSDK库小于容器版本，请将前端库升级到最新版本"
      },
      ERROR_TYPE_QUESTTIMEDOUT: {
        code: 2006,
        msg: "请求超时"
      },
      ERROR_TYPE_NATIVE: {
        code: 3e3,
        msg: "捕获到一处原生容器错误"
      },
      ERROR_TYPE_NATIVECALL: {
        code: 3001,
        msg: "原生调用H5时参数不对"
      },
      ERROR_TYPE_UNKNOWN: {
        code: 9999,
        msg: "未知错误"
      }
    };

    function o(e) {
      console.error("[hybridJs error]: " + e)
    }

    function a(e) {
      console.log("[hybridJs log]: " + e)
    }

    function i(e) {
      const t = e;
      window.JSBridge = {};
      const s = window.JSBridge,
        n = t.showError,
        a = t.globalError,
        i = t.os;
      t.JSBridge = s;
      const c = {},
        r = {},
        l = {};
      let d = 2147483647;

      function u(e, t) {
        let s, n, o, a = "BWTJSBridge://" + e;
        var i;
        return t.callbackId && (s = t.callbackId, n = t.handlerName, o = t.data), o = encodeURIComponent(
          "string" != typeof(i = o) ? JSON.stringify(i) : i), a += `:${s}/${n}?${o}`, a
      }

      function p(e, t, s, n) {
        const a = t;
        if ("function" == typeof s) {
          const e = Math.floor(Math.random() * d);
          r[e] = s, a.callbackId = e
        } else a.callbackId = s;
        const c = u(e, a);
        i.bwtHybrid ? i.ios ? window.webkit.messageHandlers.WKWebViewJavascriptBridge.postMessage(c) : window
          .top.prompt(c, "") : o("浏览器中jsbridge无效,对应scheme:" + c), n && setTimeout(() => {
            const e = a.callbackId,
              t = r[e] || l[e];
            t && t({
              msg: `${a.handlerName},请求超时,超时时间为：${n}`,
              code: 0
            }), delete r[a.callbackId]
          }, n)
      }
      s.registerHandler = function(e, t) {
        c[e] = t
      }, s.registerLongCallback = function(e, t) {
        l[e] = t
      }, s.getLongCallbackId = function() {
        return d -= 1, d
      }, s.callHandler = function(e, t, s, n, o) {
        p(e, {
          handlerName: t,
          data: s
        }, n, o)
      }, s._handleMessageFromNative = function(e) {
        console.log("API返回： messageJSON = ", JSON.stringify(e)), setTimeout((function() {
          let t;
          try {
            "string" == typeof e ? (t = decodeURIComponent(e), t = JSON.parse(t)) : t = e
          } catch (e) {
            return void n(a.ERROR_TYPE_NATIVECALL.code, a.ERROR_TYPE_NATIVECALL.msg)
          }
          const s = t.responseId,
            o = t.responseData;
          let i;
          if (s) i = r[s], i = i || l[s], i && i(o), delete r[s];
          else {
            const e = c[t.handlerName],
              s = t.data;
            e && e(s)
          }
        }))
      }
    }

    function c(e) {
      const t = Object.prototype.toString.call(e).match(/^\[object\s(.*)\]$/)[1];
      return "String" !== t && "Number" !== t && "Boolean" !== t && "Undefined" !== t && "Null" !== t
    }
    const r = () => {};

    function l(e, ...t) {
      const s = e;
      return t.forEach(e => {
        Object.keys(e).forEach(t => {
          s[t] = e[t]
        })
      }), s
    }

    function d(e = "", t = 6) {
      let s = 0;
      return e.split("").filter(e => (s += /[\u4e00-\u9fa5]/.test(e) ? 2 : 1, s <= t)).join("")
    }

    function u(e) {
      if (/^(http|https|ftp|\/\/)/g.test(e)) return e;
      return /(\.\/)|(\.\.\/)/.test(e) ? function(e) {
          const t = window.location,
            s = t.pathname,
            n = e.match(/\.\.\//g),
            o = n && n.length || 0,
            a = s.split("/");
          let i = `${a.slice(0,a.length-(o+1)).join("/")}/${e.replace(/\.+\//g,"")}`;
          return i = `${t.protocol}//${t.host}${i}`, i
        }(e) :
        `${function(){const e=window.location,t=e.pathname.split("/"),s=t.length>2,n=t[Number(s)]+"/";return`${e.protocol}//${e.host}/${n}`.replace(/[/]{2}$/,"/")}()}${e}`
    }

    function p(e = "", t) {
      let s = u(e),
        n = "";
      return t && Object.keys(t).forEach(e => {
        -1 === n.indexOf("?") && -1 === s.indexOf("?") ? n += "?" : n += "&", n += `${e}=${t[e]}`
      }), s += n, s
    }

    function m(e) {
      return function(t, s, n) {
        const o = t.success,
          a = t.error,
          i = t.dataFilter,
          c = t.proto,
          r = t.handlerName,
          l = t.isLongCb,
          d = t.isEvent,
          u = t.data,
          p = u.requestTimedOut,
          m = e => {
            if (1 === e.code) {
              let t = e;
              i && (t = i(t)), o && o(t.result), !l && s && s(t.result)
            } else a && a(e), !l && n && n(e)
          };
        if (l) {
          const t = e.getLongCallbackId();
          d && (u.port = t), e.registerLongCallback(t, m), e.callHandler(c, r, u, t, p), s && s()
        } else e.callHandler(c, r, u, m, p)
      }
    }

    function b(e) {
      const t = e,
        s = t.Proxy,
        n = t.globalError,
        o = t.showError,
        a = t.os,
        i = t.callInner,
        c = {},
        l = {},
        d = ["bwtHybrid", "dd", "h5"];

      function u(e, t, s, i) {
        Object.defineProperty(e, t, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            const e = c[s],
              t = e[function(e) {
                for (let t = 0, s = d.length; t < s; t += 1)
                  if (e[d[t]]) return d[t];
                return "h5"
              }(a)] || e.h5;
            if (t) return t.walk();
            const l = i.os ? i.os.join("或") : '"非法"',
              u = `${i.namespace}要求的os环境为:${l}`;
            return o(n.ERROR_TYPE_APIOS.code, u), r
          },
          set: function() {
            o(n.ERROR_TYPE_APIMODIFY.code, n.ERROR_TYPE_APIMODIFY.msg)
          }
        })
      }

      function p(e) {
        Object.defineProperty(t, e, {
          configurable: !0,
          enumerable: !0,
          get: function() {
            return l[e] || (l[e] = {}), l[e]
          },
          set: function() {
            o(n.ERROR_TYPE_MODULEMODIFY.code, n.ERROR_TYPE_MODULEMODIFY.msg)
          }
        })
      }

      function m(e, n) {
        if (!n || !n.namespace) return;
        t[e] || p(e);
        const o = n,
          a = t[e],
          r = o.namespace;
        o.moduleName = e;
        const l = function(e, t) {
            let s = e;
            return (/[.]/.test(t) ? t.replace(/[.][^.]+$/, "").split(".") : []).forEach(e => {
              s[e] = s[e] || {}, s = s[e]
            }), s
          }(a, r),
          m = `${e}.${o.namespace}`,
          b = /[.]/.test(r) ? o.namespace.match(/[.][^.]+$/)[0].substr(1) : r;
        c[m] || u(l, b, m, o);
        let g = o.runCode;
        !g && i && (g = i);
        const h = new s(o, g),
          f = c[m] || {},
          y = {};
        c[m] = {}, d.forEach(e => {
          o.os && -1 !== o.os.indexOf(e) ? (c[m][e] = h, y[e] = !0) : f[e] && (c[m][e] = f[e], o.os && o.os
            .push(e))
        }), Object.keys(y).forEach(e => {
          f[e] && f[e].dispose()
        })
      }
      t.extendModule = function(e, s) {
        if (s && Array.isArray(s)) {
          t[e] || p(e);
          for (let t = 0, n = s.length; t < n; t += 1) m(e, s[t])
        }
      }, t.extendApi = m
    }

    function g(e) {
      const t = e,
        s = t.globalError,
        n = t.showError,
        o = t.JSBridge;
      let i, c = !1,
        r = !1;
      t.config = function(e) {
        if (r) n(s.ERROR_TYPE_CONFIGMODIFY.code, s.ERROR_TYPE_CONFIGMODIFY.msg);
        else {
          r = !0;
          const o = () => {
            i ? (a("ready!"), i()) : c = !0
          };
          t.os.bwtHybrid ? (t.runtime && t.runtime.getBridgeVersion ? t.runtime.getBridgeVersion({
            success: e => {
              const s = e.version;
              a(`hybridJs.version：${t.version};容器的版本：${s}`)
            },
            error: () => {
              n(s.ERROR_TYPE_INITVERSIONERROR.code, s.ERROR_TYPE_INITVERSIONERROR.msg)
            }
          }) : n(s.ERROR_TYPE_VERSIONNOTSUPPORT.code, s.ERROR_TYPE_VERSIONNOTSUPPORT.msg), t.auth.config(
            l({
              success() {
                o()
              },
              error(e) {
                const t = JSON.stringify(e);
                n(s.ERROR_TYPE_CONFIGERROR.code, t)
              }
            }, e || {}))) : o()
        }
      }, t.ready = function(e) {
        i ? n(s.ERROR_TYPE_READYMODIFY.code, s.ERROR_TYPE_READYMODIFY.msg) : (i = e, c && (a("ready!"), c = !
          1, i()))
      }, o.registerHandler("handleError", e => {
        n(s.ERROR_TYPE_NATIVE.code, JSON.stringify(e))
      })
    }
    const h = [],
      f = (() => {
        const e = document.createElement("div");
        return e.classList.add("mui-popup-backdrop"), e.addEventListener("webkitTransitionEnd", () => {
          e.classList.contains("mui-active") || e.parentNode && e.parentNode.removeChild(e)
        }), e
      })(),
      y = (e, t, s) =>
      `<div class="mui-popup-inner">${`<div class="mui-popup-title">${t}</div>`}${`<div class="mui-popup-text">${e}</div>`}${s||""}</div>`,
      w = e => {
        const t = e.length,
          s = [];
        for (let n = 0; n < t; n += 1) {
          const o = n === t - 1 ? "mui-popup-button-bold" : "";
          s.push(`<span class="mui-popup-button ${o}">${e[n]}</span>`)
        }
        return `<div class="mui-popup-buttons">${s.join("")}</div>`
      },
      O = (e, t) => {
        const s = e.replace(/[\n]/g, "<BR />");
        let n = document.createElement("div");
        n.className = "mui-popup", n.innerHTML = s;
        const o = () => {
          n.parentNode && n.parentNode.removeChild(n), n = null
        };
        n.addEventListener("webkitTransitionEnd", e => {
            n && e.target === n && n.classList.contains("mui-popup-out") && o()
          }), n.style.display = "block", document.body.appendChild(n), n.classList.add("mui-popup-in"), f.classList
          .contains("mui-active") || (f.style.display = "block", document.body.appendChild(f), f.classList.add(
            "mui-active"));
        const a = n.querySelectorAll(".mui-popup-button"),
          i = n.querySelector(".mui-popup-input input"),
          c = {
            element: n,
            close(e, s) {
              if (n) {
                const a = i ? i.value : e || 0;
                t && t(a, {
                    index: e || 0,
                    value: a
                  }), !1 !== s ? (n.classList.remove("mui-popup-in"), n.classList.add("mui-popup-out")) : o(),
                  h.pop(), h.length ? h[h.length - 1].show(s) : f.classList.remove("mui-active")
              }
            }
          },
          r = e => {
            c.close([].slice.call(a).indexOf(e.target))
          },
          l = document.querySelectorAll(".mui-popup-button");
        if (l && l.length > 0)
          for (let e = 0; e < l.length; e += 1) l[e].addEventListener("click", r);
        return h.length && h[h.length - 1].hide(), h.push({
          close: c.close,
          show() {
            n.style.display = "block", n.classList.add("mui-popup-in")
          },
          hide() {
            n.style.display = "none", n.classList.remove("mui-popup-in")
          }
        }), c
      };
    let v;

    function E(e, t) {
      this.loadingDiv = function() {
          let e = document.getElementById("MFRAME_LOADING");
          if (!e) {
            e = document.createElement("div"), e.id = "MFRAME_LOADING", e.className =
              "mui-backdrop mui-loading";
            const t =
              "width: 20%;height: 20%;\n        max-width: 46px;max-height: 46px;\n        position:absolute;top:46%;left:46%;",
              s =
              "position:absolute;\n        font-size: 14px;\n        top:54%;left: 46%;\n        text-align: center;";
            e.innerHTML =
              ` \n        <span class=" mui-spinner mui-spinner-white"\n            style="${t}">\n        </span>\n        <span class="tipsContent" style="${s}">\n                        加载中...\n        </span>`
          }
          return e
        }(), document.body.appendChild(this.loadingDiv), this.setTitle(e), t && !0 === t.padlock && this.loadingDiv
        .addEventListener("click", () => {
          this.close()
        })
    }
    E.prototype.setTitle = function(e) {
      this.loadingDiv && (this.loadingDiv.style.display = "block", this.loadingDiv.querySelector(
        ".tipsContent").innerText = e || "")
    }, E.prototype.onclose = () => {}, E.prototype.close = function() {
      this.loadingDiv && (this.loadingDiv.style.display = "none", this.onclose())
    }, E.prototype.dispose = function() {
      this.loadingDiv && this.loadingDiv.parentNode && this.loadingDiv.parentNode.removeChild(this.loadingDiv)
    };

    function R(e, t) {
      const s = e;
      s.id = s.id || "defaultActionSheetId";
      const n = function(e) {
        const t = e || {};
        let s = "";
        if (s +=
          `<div ${t.id?`id="${t.id}"`:""} class="mui-popover mui-popover-action mui-popover-bottom">`, t.title &&
          (s += '<ul class="mui-table-view">', s += '<li class="mui-table-view-cell">', s +=
            `<a class="titleActionSheet"><b>${t.title}</b></a>`, s += "</li>", s += "</ul>"), s +=
          '<ul class="mui-table-view">', t.items && Array.isArray(t.items))
          for (let e = 0; e < t.items.length; e += 1) {
            s += '<li class="mui-table-view-cell">', s += `<a >${t.items[e]||""}</a>`, s += "</li>"
          }
        return s += "</ul>", s += '<ul class="mui-table-view">', s += '<li class="mui-table-view-cell">', s +=
          '<a class="cancelActionSheet"><b>取消</b></a>', s += "</li>", s += "</ul>", s += "</div>", s
      }(s);
      if (document.getElementById("actionSheetContent")) document.getElementById(
        "defaultActionSheetWrapContent").innerHTML = n;
      else {
        const e = document.createElement("div");
        e.id = "defaultActionSheetWrapContent", e.innerHTML = n, document.body.appendChild(e), mui("body").on(
          "shown", ".mui-popover", () => {}), mui("body").on("hidden", ".mui-popover", () => {})
      }
      const o = document.getElementById("defaultActionSheetWrapContent");
      mui(o).off(), mui(o).on("tap", "li > a", (function() {
        const e = this.innerText; - 1 === this.className.indexOf("titleActionSheet") && (mui("#" + s.id)
          .popover("toggle"), -1 === this.className.indexOf("cancelActionSheet") && t && t(e))
      })), mui("#" + s.id).popover("toggle")
    }
    let P, H, S, I;

    function T(e) {
      let t = e;
      return "number" == typeof t || "string" == typeof t ? (t = parseInt(t, 10), t < 10 && (t = "0" + t), t) :
        ""
    }

    function C(e) {
      const t = e[0],
        s = e[1];
      ! function(e, t) {
        const s = e || {};
        window.mui && window.mui.DtPicker ? (H !== s.type && (P && (P.dispose(), P = void 0), H = s.type), P =
          P || new mui.DtPicker(s), P.show(e => {
            const n = {};
            "date" === s.type ? n.date = `${e.y.value}-${e.m.value}-${e.d.value}` : "time" === s.type ? n
              .time = `${e.h.value}:${e.i.value}` : "month" === s.type ? n.month =
              `${e.y.value}-${e.m.value}` : n.datetime =
              `${e.y.value}-${e.m.value}-${e.d.value} ${e.h.value}:${e.i.value}`, t && t(n)
          })) : console.error("错误,缺少引用的css或js,无法使用mui的dtpicker")
      }(t, e => {
        t.success && t.success(e), s && s(e)
      })
    }

    function N(e) {
      const t = e,
        s = t.innerUtil;
      t.extendModule("ui", [{
        namespace: "toast",
        os: ["h5"],
        defaultParams: {
          message: ""
        },
        runCode(...e) {
          const t = s.compatibleStringParamsToObject.call(this, e, "message"),
            n = t[0],
            o = t[1];
          ! function(e) {
            const t = e,
              s = t.message,
              n = t.duration || 2e3;
            let o = document.createElement("div");
            o.classList.add("mui-toast-container"), o.innerHTML =
              `<div class="mui-toast-message">${s}</div>`, o.addEventListener("webkitTransitionEnd", () => {
                o.classList.contains("mui-active") || (o.parentNode.removeChild(o), o = null)
              }), o.addEventListener("click", () => {
                o.parentNode.removeChild(o), o = null
              }), document.body.appendChild(o), o.classList.add("mui-active"), setTimeout(() => {
                o && o.classList.remove("mui-active")
              }, n)
          }(n), n.success && n.success(), o && o()
        }
      }, {
        namespace: "showDebugDialog",
        os: ["h5"],
        defaultParams: {
          debugInfo: ""
        },
        runCode(...e) {
          const n = s.compatibleStringParamsToObject.call(this, e, "debugInfo");
          n[0] = {
            title: "",
            message: n[0].debugInfo,
            buttonName: "确定",
            success: n[0].success
          }, t.ui.alert.apply(this, n)
        }
      }, {
        namespace: "alert",
        os: ["h5"],
        defaultParams: {
          title: "",
          message: "",
          buttonName: "确定"
        },
        runCode(...e) {
          const t = s.compatibleStringParamsToObject.call(this, e, "message", "title", "buttonName"),
            n = t[0],
            o = t[1];
          ! function(e, t) {
            const s = e;
            s.title = s.title || "提示", s.buttonName = s.buttonName || "确定", s.message = s.message || "";
            const n = y(s.message, s.title),
              o = w([s.buttonName]);
            O(n + o, t)
          }(n, () => {
            n.success && n.success({}), o && o({})
          })
        }
      }, {
        namespace: "confirm",
        os: ["h5"],
        defaultParams: {
          title: "",
          message: "",
          buttonLabels: ["取消", "确定"]
        },
        runCode(...e) {
          const t = e,
            s = t[0],
            n = t[1];
          ! function(e, t) {
            const s = e;
            s.title = s.title || "提示", s.buttonLabels = s.buttonLabels || ["确认", "取消"], s.message = s.message ||
              "";
            const n = y(s.message, s.title),
              o = w(s.buttonLabels);
            O(n + o, t)
          }(s, e => {
            const t = {
              which: e
            };
            s.success && s.success(t), n && n(t)
          })
        }
      }, {
        namespace: "prompt",
        os: ["h5"],
        defaultParams: {
          title: "",
          hint: "",
          text: "",
          buttonLabels: ["取消", "确定"]
        },
        runCode(...e) {
          const t = e,
            s = t[0],
            n = t[1];
          ! function(e, t) {
            const s = e;
            s.title = s.title || "您好", s.buttonLabels = s.buttonLabels || ["确认", "取消"], s.text = s.text ||
              "", s.hint = s.hint || "请输入内容";
            const n = y(s.text, s.title,
                `<div class="mui-popup-input"><input type="text" autofocus placeholder="${s.hint||""}"/></div>`
              ),
              o = w(s.buttonLabels);
            O(n + o, t)
          }(s, e => {
            const t = {
              which: e ? 1 : 0,
              content: e
            };
            s.success && s.success(t), n && n(t)
          })
        }
      }, {
        namespace: "actionSheet",
        os: ["h5"],
        defaultParams: {
          items: []
        },
        runCode(...e) {
          const t = e,
            s = t[0],
            n = t[1];
          R(s, e => {
            const t = {
              which: s.items.indexOf(e),
              content: e
            };
            s.success && s.success(t), n && n(t)
          })
        }
      }, {
        namespace: "pickDate",
        os: ["h5"],
        defaultParams: {
          beginYear: 1900,
          endYear: 2100,
          datetime: ""
        },
        runCode(...e) {
          const t = e,
            s = t[0];
          let n = s.datetime;
          if (!n) {
            const e = new Date;
            n =
              `${e.getFullYear()}\n                -${T(e.getMonth()+1)}\n                -${T(e.getDate())}`
          }
          s.value = n, s.type = "date", C(t)
        }
      }, {
        namespace: "pickTime",
        os: ["h5"],
        defaultParams: {
          datetime: ""
        },
        runCode(...e) {
          const t = e,
            s = t[0],
            n = new Date,
            o =
            `${n.getFullYear()}\n                -${T(n.getMonth()+1)}\n                -${T(n.getDate())} `;
          let a = s.datetime;
          if (a) a = o + a;
          else {
            a = o + `${T(n.getHours())}\n                :${T(n.getMinutes())}`
          }
          s.value = a, s.type = "time", C(t)
        }
      }, {
        namespace: "pickDateTime",
        os: ["h5"],
        defaultParams: {
          datetime: "",
          beginYear: 1900,
          endYear: 2100
        },
        runCode(...e) {
          const t = e,
            s = t[0];
          let n = s.datetime;
          if (!n) {
            const e = new Date;
            n =
              `${e.getFullYear()}\n                -${T(e.getMonth()+1)}\n                -${T(e.getDate())} ` +
              `${T(e.getHours())}\n                :${T(e.getMinutes())}`
          }
          s.value = n, s.type = null, C(t)
        }
      }, {
        namespace: "pickMonth",
        os: ["h5"],
        defaultParams: {
          datetime: "",
          beginYear: 1900,
          endYear: 2100
        },
        runCode(...e) {
          const t = e,
            s = t[0],
            n = new Date;
          let o = s.datetime;
          o ? o += "-" + T(n.getDate()) : o =
            `${n.getFullYear()}\n                -${T(n.getMonth()+1)}\n                -${T(n.getDate())} `,
            s.value = o, s.type = "month", C(t)
        }
      }, {
        namespace: "popPicker",
        os: ["h5"],
        defaultParams: {
          layer: 1,
          data: []
        },
        runCode(...e) {
          const t = e,
            s = t[0],
            n = t[1];
          ! function(e, t) {
            const s = e || {};
            if (window.mui && window.mui.PopPicker) {
              const e = s.layer || 1;
              I !== e && (S && (S.dispose(), S = void 0), I = e), S = S || new mui.PopPicker({
                layer: e
              }), S.setData(s.data || []), S.show(s => {
                const n = {
                  items: []
                };
                for (let t = 0; t < e; t += 1) n.items.push({
                  text: s[t].text,
                  value: s[t].value
                });
                t && t(n)
              })
            } else console.error("未引入mui pop相关js(css)")
          }(s, e => {
            s.success && s.success(e), n && n(e)
          })
        }
      }, {
        namespace: "showWaiting",
        os: ["h5"],
        defaultParams: {
          message: "",
          padlock: !0
        },
        runCode(...e) {
          const t = e,
            s = t[0],
            n = t[1];
          ! function(e, t) {
            void 0 === v ? v = new E(e, t) : v.setTitle(e)
          }(s.message, {
            padlock: s.padlock
          }), s.success && s.success({}), n && n({})
        }
      }, {
        namespace: "closeWaiting",
        os: ["h5"],
        runCode(...e) {
          const t = e,
            s = t[0],
            n = t[1];
          v && (v.dispose(), v = void 0), s.success && s.success(), n && n()
        }
      }])
    }

    function k(e, t) {
      t || (t = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
      var s = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(t);
      return s ? s[2] ? decodeURIComponent(s[2].replace(/\+/g, " ")) : "" : null
    }
    const _ = {};
    ! function(e) {
      const t = e;
      ! function(e) {
        (function(e) {
          this.os = {};
          const t = e.match(/(Android);?[\s/]+([\d.]+)?/);
          t && (this.os.android = !0, this.os.version = t[2], this.os.isBadAndroid = !/Chrome\/\d/.test(
            window.navigator.appVersion));
          const s = e.match(/(iPhone\sOS)\s([\d_]+)/);
          s && (this.os.ios = !0, this.os.iphone = !0, this.os.version = s[2].replace(/_/g, "."));
          const n = e.match(/(iPad).*OS\s([\d_]+)/);
          n && (this.os.ios = !0, this.os.ipad = !0, this.os.version = n[2].replace(/_/g, "."));
          const o = e.match(/BWTJSBridge/i);
          o && (this.os.bwtHybrid = !0);
          const a = e.match(/DingTalk/i);
          a && (this.os.dd = !0), a || o || (this.os.h5 = !0)
        }).call(e, navigator.userAgent)
      }(t),
      function(e) {
        const t = e;
        t.Promise = window.Promise, t.getPromise = () => t.Promise, t.setPromise = e => {
          t.Promise = e
        }
      }(t),
      function(e) {
        const t = e;
        let s;
        t.showError = function(e = 0, t = "错误!") {
          o(`code:${e}, msg:${t}`), s && s({
            code: e,
            message: t
          })
        }, t.globalError = n, t.error = function(e) {
          s = e
        }
      }(t),
      function(e) {
        const t = e;

        function s(e, t) {
          this.api = e, this.callback = t
        }
        s.prototype.walk = function() {
          const e = t.getPromise();
          return (...t) => {
            let s, n = t;
            return n[0] = n[0] || {}, this.api.defaultParams && n[0] instanceof Object && Object.keys(
              this.api.defaultParams).forEach(e => {
              void 0 === n[0][e] && (n[0][e] = this.api.defaultParams[e])
            }), this.callback && (s = this.callback), e ? s && new e((e, t) => {
              n = n.concat([e, t]), s.apply(this, n)
            }) : s && s.apply(this, n)
          }
        }, s.prototype.dispose = function() {
          this.api = null, this.callback = null
        }, t.Proxy = s
      }(t), i(t),
        function(e) {
          const t = e,
            s = t.os,
            n = m(t.JSBridge);
          t.callInner = function(e, t, o) {
            const a = l({}, e);
            a.success = void 0, a.error = void 0, a.dataFilter = void 0, s.bwtHybrid && n({
              handlerName: this.api.namespace,
              data: a,
              proto: this.api.moduleName,
              success: e.success,
              error: e.error,
              dataFilter: e.dataFilter,
              isLongCb: this.api.isLongCb,
              isEvent: this.api.isEvent
            }, t, o)
          }
        }(t), b(t),
        function(e) {
          const t = e,
            s = m(t.JSBridge);

          function n(e) {
            const n = t.getPromise(),
              o = e || {},
              a = (e, t) => {
                s({
                  handlerName: o.name,
                  proto: o.mudule,
                  data: o.data || {},
                  success: o.success,
                  error: o.error,
                  isLongCb: o.isLongCb,
                  isEvent: o.isEvent
                }, e, t)
              };
            return n && new n(a) || a()
          }
          t.callApi = n, t.callNativeApi = n
        }(t), g(t),
        function(e) {
          const t = e,
            s = {};
          t.innerUtil = s, s.extend = l, s.isObject = c, s.getFullPath = u, s.getFullUrlByParams = p, s.eclipseText =
            d, s.compatibleStringParamsToObject = function(e, ...n) {
              const o = e;
              if (!s.isObject(o[0])) {
                const e = {},
                  s = !!t.getPromise(),
                  a = o.length,
                  i = s ? a - 2 : a;
                for (let t = 0; t < i; t += 1) void 0 !== n[t] && (e[n[t]] = o[t]);
                o[0] = e, s ? (o[1] = o[a - 2], o[2] = o[a - 1]) : (o[1] = void 0, o[2] = void 0)
              }
              return this.api && this.api.defaultParams && o[0] instanceof Object && Object.keys(this.api.defaultParams)
                .forEach(e => {
                  void 0 === o[0][e] && (o[0][e] = this.api.defaultParams[e])
                }), o
            }
        }(t)
    }(_),
    function(e) {
      const t = e;
      N(t),
        function(e) {
          const t = e,
            s = t.innerUtil;
          t.extendModule("page", [{
            namespace: "open",
            os: ["h5"],
            defaultParams: {
              pageUrl: "",
              data: {}
            },
            runCode(...e) {
              const t = s.compatibleStringParamsToObject.call(this, e, "pageUrl", "data")[0];
              t.pageUrl = s.getFullUrlByParams(t.pageUrl, t.data), document.location.href = t.pageUrl
            }
          }, {
            namespace: "close",
            os: ["h5"],
            runCode() {
              window.history.length > 1 && window.history.back()
            }
          }, {
            namespace: "reload",
            os: ["h5"],
            runCode() {
              window.location.reload()
            }
          }, {
            namespace: "push",
            os: ["h5"],
            defaultParams: {
              pageUrl: "",
              data: {}
            },
            runCode(...e) {
              document.location.href = e[0].params.pageUrl
            }
          }])
        }(t),
        function(e) {
          const t = e,
            s = t.innerUtil;
          t.extendModule("storage", [{
            namespace: "getItem",
            os: ["h5"],
            defaultParams: {
              key: ""
            },
            runCode(e, t, n) {
              const o = e,
                a = o.success,
                i = o.error;
              s.isObject(o.key) || (o.key = [o.key]);
              const c = o.key,
                r = {};
              try {
                for (let e = 0, t = c.length; e < t; e += 1) {
                  const t = localStorage.getItem(c[e]);
                  r[c[e]] = t
                }
              } catch (e) {
                const t = {
                  code: 0,
                  msg: "localStorage获取值出错:" + JSON.stringify(c),
                  result: e
                };
                return i && i(t), void(n && n(t))
              }
              a && a(r), t && t(r)
            }
          }, {
            namespace: "setItem",
            os: ["h5"],
            runCode(e, t, s) {
              const n = e,
                o = n.success,
                a = n.error;
              try {
                Object.keys(n).forEach(e => {
                  if ("success" !== e && "error" !== e) {
                    const t = n[e];
                    localStorage.setItem(e, t)
                  }
                })
              } catch (e) {
                let t = "";
                t = "QuotaExceededError" === e.name ? "超出本地存储限额，建议先清除一些无用空间!" : "localStorage存储值出错";
                const n = {
                  code: 0,
                  msg: t,
                  result: e
                };
                return a && a(n), void(s && s(n))
              }
              o && o({}), t && t({})
            }
          }, {
            namespace: "removeItem",
            os: ["h5"],
            defaultParams: {
              key: ""
            },
            runCode(e, t, n) {
              const o = e,
                a = o.success,
                i = o.error;
              s.isObject(o.key) || (o.key = [o.key]);
              const c = o.key;
              try {
                for (let e = 0, t = c.length; e < t; e += 1) localStorage.removeItem(c[e])
              } catch (e) {
                const t = {
                  code: 0,
                  msg: "localStorage移除值出错:" + JSON.stringify(c),
                  result: e
                };
                return i && i(t), void(n && n(t))
              }
              a && a({}), t && t({})
            }
          }])
        }(t),
        function(e) {
          const t = e,
            s = t.innerUtil;
          t.extendModule("device", [{
            namespace: "callPhone",
            os: ["h5"],
            defaultParams: {
              phoneNum: ""
            },
            runCode(...e) {
              const t = s.compatibleStringParamsToObject.call(this, e, "phoneNum")[0].phoneNum;
              window.location.href = "tel:" + t
            }
          }, {
            namespace: "sendMsg",
            os: ["h5"],
            defaultParams: {
              phoneNum: "",
              message: ""
            },
            runCode(...e) {
              const t = s.compatibleStringParamsToObject.call(this, e, "phoneNum", "message"),
                n = t[0].phoneNum,
                o = t[0].message;
              window.location.href = `sms:${n}?body=${o}`
            }
          }, {
            namespace: "sendMail",
            os: ["h5"],
            defaultParams: {
              mail: "",
              subject: "",
              cc: ""
            },
            runCode(...e) {
              const t = s.compatibleStringParamsToObject.call(this, e, "mail", "subject", "cc"),
                n = t[0].mail,
                o = t[0].subject,
                a = t[0].cc;
              window.location.href = `mailto:${n}?subject=${o}&cc=${a}`
            }
          }, {
            namespace: "getNetworkStatus",
            os: ["h5"],
            runCode(e, t, s) {
              t(!0)
            }
          }])
        }(t),
        function(e) {
          const t = e;
          t.innerUtil, t.extendModule("runtime", [{
            namespace: "getCityInfo",
            os: ["h5"],
            runCode(e, t, s) {
              let n = sessionStorage.getItem("getCityInfo");
              if (n) n = JSON.parse(n);
              else {
                n = {
                  cityId: k("cityId")
                }, sessionStorage.setItem("getCityInfo", JSON.stringify(n))
              }
              t(n)
            }
          }, {
            namespace: "getAppInfo",
            os: ["h5"],
            runCode(e, t, s) {
              let n = sessionStorage.getItem("getAppInfo");
              if (n) n = JSON.parse(n), console.error("info", n);
              else {
                n = {
                  appId: k("appId"),
                  publicKey: k("publicKey")
                }, sessionStorage.setItem("getAppInfo", JSON.stringify(n))
              }
              console.error("info", n), t(n)
            }
          }])
        }(t),
        function(e) {
          const t = e;
          t.innerUtil, t.extendModule("user", [{
            namespace: "getToken",
            os: ["h5"],
            runCode(e, t, s) {
              let n = sessionStorage.getItem("getToken");
              if (n) n = JSON.parse(n);
              else {
                n = {
                  token: k("token")
                }, sessionStorage.setItem("getToken", JSON.stringify(n))
              }
              t(n)
            }
          }])
        }(t),
        function(e) {
          const t = e;
          t.innerUtil, t.extendModule("navigator", [{
            namespace: "setRightBtn",
            os: ["h5"]
          }, {
            namespace: "hideRightBtn",
            os: ["h5"]
          }])
        }(t)
    }(_),
    function(e) {
      const t = e;
      ! function(e) {
        const t = e,
          s = t.innerUtil;
        t.extendModule("ui", [{
          namespace: "toast",
          os: ["bwtHybrid"],
          defaultParams: {
            message: ""
          },
          runCode(...e) {
            const n = s.compatibleStringParamsToObject.call(this, e, "message");
            t.callInner.apply(this, n)
          }
        }, {
          namespace: "alert",
          os: ["bwtHybrid"]
        }, {
          namespace: "confirm",
          os: ["bwtHybrid"]
        }, {
          namespace: "prompt",
          os: ["bwtHybrid"]
        }, {
          namespace: "showWaiting",
          os: ["bwtHybrid"]
        }, {
          namespace: "closeWaiting",
          os: ["bwtHybrid"]
        }, {
          namespace: "actionSheet",
          os: ["bwtHybrid"]
        }, {
          namespace: "pickDate",
          os: ["bwtHybrid"]
        }, {
          namespace: "pickTime",
          os: ["bwtHybrid"]
        }, {
          namespace: "pickDateTime",
          os: ["bwtHybrid"]
        }, {
          namespace: "pickMonth",
          os: ["bwtHybrid"]
        }, {
          namespace: "popPicker",
          os: ["bwtHybrid"]
        }])
      }(t),
      function(e) {
        e.extendModule("auth", [{
          namespace: "getToken",
          os: ["bwtHybrid"]
        }, {
          namespace: "config",
          os: ["bwtHybrid"],
          defaultParams: {
            jsApiList: []
          }
        }])
      }(t),
      function(e) {
        const t = e,
          s = t.innerUtil;
        t.extendModule("runtime", [{
          namespace: "launchApp",
          os: ["bwtHybrid"],
          defaultParams: {
            packageName: "",
            className: "",
            actionName: "",
            scheme: "",
            data: ""
          }
        }, {
          namespace: "getAppVersion",
          os: ["bwtHybrid"]
        }, {
          namespace: "getBridgeVersion",
          os: ["bwtHybrid"]
        }, {
          namespace: "clearCache",
          os: ["bwtHybrid"]
        }, {
          namespace: "getGeolocation",
          os: ["bwtHybrid"],
          defaultParams: {
            isShowDetail: 0,
            coordinate: 1
          }
        }, {
          namespace: "clipboard",
          os: ["bwtHybrid"],
          defaultParams: {
            text: ""
          },
          runCode(...e) {
            const n = s.compatibleStringParamsToObject.call(this, e, "text");
            t.callInner.apply(this, n)
          }
        }, {
          namespace: "openUrl",
          os: ["bwtHybrid"],
          defaultParams: {
            url: ""
          },
          runCode(...e) {
            const n = s.compatibleStringParamsToObject(e, "url");
            t.callInner.apply(this, n)
          }
        }, {
          namespace: "launchApp",
          os: ["bwtHybrid"]
        }, {
          namespace: "getBridgeVersion",
          os: ["bwtHybrid"]
        }, {
          namespace: "getWebviewVersion",
          os: ["bwtHybrid"]
        }, {
          namespace: "getLocation",
          os: ["bwtHybrid"]
        }, {
          namespace: "becomeActive",
          runCode(...e) {
            this.api.isLongCb = !0, t.callInner.apply(this, e)
          },
          os: ["bwtHybrid"]
        }, {
          namespace: "clearCache",
          os: ["bwtHybrid"]
        }, {
          namespace: "getClipboard",
          os: ["bwtHybrid"]
        }, {
          namespace: "setClipboard",
          os: ["bwtHybrid"]
        }, {
          namespace: "getCityInfo",
          os: ["bwtHybrid"]
        }, {
          namespace: "getAppInfo",
          os: ["bwtHybrid"]
        }, {
          namespace: "becomeBackground",
          os: ["bwtHybrid"]
        }, {
          namespace: "registNativeNotify",
          os: ["bwtHybrid"]
        }, {
          namespace: "callNativeNotify",
          os: ["bwtHybrid"]
        }])
      }(t),
      function(e) {
        e.extendModule("device", [{
          namespace: "getDeviceId",
          os: ["bwtHybrid"]
        }, {
          namespace: "getDeviceInfo",
          os: ["bwtHybrid"]
        }, {
          namespace: "phoneCall",
          os: ["bwtHybrid"]
        }, {
          namespace: "messageSend",
          os: ["bwtHybrid"]
        }, {
          namespace: "closeKeyboard",
          os: ["bwtHybrid"]
        }, {
          namespace: "makeRing",
          os: ["bwtHybrid"]
        }, {
          namespace: "makeShortVibrate",
          os: ["bwtHybrid"]
        }, {
          namespace: "makeLongVibrate",
          os: ["bwtHybrid"]
        }, {
          namespace: "getBluetoothStatus",
          os: ["bwtHybrid"]
        }, {
          namespace: "getNetworkStatus",
          os: ["bwtHybrid"]
        }, {
          namespace: "monitorBluetoothStatus",
          os: ["bwtHybrid"]
        }, {
          namespace: "monitorNetworkStatus",
          os: ["bwtHybrid"]
        }, {
          namespace: "getScreenBrightness",
          os: ["bwtHybrid"]
        }, {
          namespace: "setScreenBrightness",
          os: ["bwtHybrid"]
        }, {
          namespace: "setKeepScreenOn",
          os: ["bwtHybrid"]
        }, {
          namespace: "monitorScreenShoot",
          os: ["bwtHybrid"]
        }])
      }(t),
      function(e) {
        const t = e,
          s = t.innerUtil;
        t.extendModule("page", [{
          namespace: "open",
          os: ["bwtHybrid"],
          defaultParams: {
            pageUrl: "",
            pageStyle: 1,
            orientation: 1,
            data: {}
          },
          runCode(...e) {
            const n = s.compatibleStringParamsToObject.call(this, e, "pageUrl", "data"),
              o = n[0];
            o.pageUrl = s.getFullUrlByParams(o.pageUrl, o.data), o.data = void 0, o.dataFilter = e => {
              const t = e;
              if (!s.isObject(t.result.resultData)) try {
                t.result.resultData = JSON.parse(t.result.resultData)
              } catch (e) {}
              return t
            }, n[0] = o, t.callInner.apply(this, n)
          }
        }, {
          namespace: "openLocal",
          os: ["bwtHybrid"],
          defaultParams: {
            className: "",
            isOpenExist: 0,
            data: {}
          },
          runCode(...e) {
            const n = e,
              o = n[0];
            o.dataFilter = e => {
              const t = e;
              if (!s.isObject(t.result.resultData)) try {
                t.result.resultData = JSON.parse(t.result.resultData)
              } catch (e) {}
              return t
            }, n[0] = o, t.callInner.apply(this, n)
          }
        }, {
          namespace: "close",
          os: ["bwtHybrid"],
          defaultParams: {
            resultData: ""
          },
          runCode(...e) {
            const n = s.compatibleStringParamsToObject.call(this, e, "resultData");
            s.isObject(n[0].resultData) && (n[0].resultData = JSON.stringify(n[0].resultData)), t.callInner
              .apply(this, n)
          }
        }, {
          namespace: "reload",
          os: ["bwtHybrid"]
        }, {
          namespace: "push",
          os: ["bwtHybrid"]
        }, {
          namespace: "replace",
          os: ["bwtHybrid"]
        }, {
          namespace: "pop",
          os: ["bwtHybrid"]
        }, {
          namespace: "appear",
          runCode(...e) {
            this.api.isLongCb = !0, t.callInner.apply(this, e)
          },
          os: ["bwtHybrid"]
        }, {
          namespace: "reloadWebview",
          os: ["bwtHybrid"]
        }, {
          namespace: "disappear",
          os: ["bwtHybrid"]
        }])
      }(t),
      function(e) {
        const t = e,
          s = t.innerUtil;
        t.extendModule("navigator", [{
          namespace: "setTitle",
          os: ["bwtHybrid"],
          defaultParams: {
            title: "",
            subTitle: "",
            direction: "bottom",
            clickable: 0
          },
          runCode(...e) {
            const n = s.compatibleStringParamsToObject.call(this, e, "title");
            this.api.isLongCb = !0, t.callInner.apply(this, n)
          }
        }, {
          namespace: "setMultiTitle",
          os: ["bwtHybrid"],
          defaultParams: {
            titles: ""
          },
          runCode(...e) {
            this.api.isLongCb = !0, t.callInner.apply(this, e)
          }
        }, {
          namespace: "hideRightBtn",
          os: ["bwtHybrid"]
        }, {
          namespace: "showRightBtn",
          os: ["bwtHybrid"]
        }, {
          namespace: "hideLeftBtn",
          os: ["bwtHybrid"]
        }, {
          namespace: "showLeftBtn",
          os: ["bwtHybrid"]
        }, {
          namespace: "hide",
          os: ["bwtHybrid"]
        }, {
          namespace: "show",
          os: ["bwtHybrid"]
        }, {
          namespace: "setNavTitle",
          os: ["bwtHybrid"]
        }, {
          namespace: "showStatusBar",
          os: ["bwtHybrid"]
        }, {
          namespace: "hideStatusBar",
          os: ["bwtHybrid"]
        }, {
          namespace: "hideBackBtn",
          os: ["bwtHybrid"]
        }, {
          namespace: "hookSysBack",
          os: ["bwtHybrid"],
          runCode(...e) {
            this.api.isLongCb = !0, t.callInner.apply(this, e)
          }
        }, {
          namespace: "hookBackBtn",
          os: ["bwtHybrid"],
          runCode(...e) {
            this.api.isLongCb = !0, t.callInner.apply(this, e)
          }
        }, {
          namespace: "setRightBtn",
          os: ["bwtHybrid"],
          runCode(...e) {
            const n = e,
              o = n[0];
            o.imageUrl = o.imageUrl && s.getFullPath(o.imageUrl), o.text = s.eclipseText(o.text, 10), n[
              0] = o, this.api.isLongCb = !0, t.callInner.apply(this, n)
          }
        }, {
          namespace: "setRightMenu",
          os: ["bwtHybrid"],
          defaultParams: {
            text: "",
            imageUrl: "",
            iconFilterColor: "",
            titleItems: [],
            iconItems: []
          },
          runCode(...e) {
            const n = [].slice.call(e),
              o = s.extend({}, n[0]);
            o.success = () => {
              t.ui.popWindow.apply(this, e)
            }, n[0] = o, t.navigator.setRightBtn.apply(this, n)
          }
        }, {
          namespace: "setLeftBtn",
          os: ["bwtHybrid"],
          runCode(...e) {
            const n = e,
              o = n[0];
            o.imageUrl = o.imageUrl && s.getFullPath(o.imageUrl), o.text = s.eclipseText(o.text, 10), n[
              0] = o, this.api.isLongCb = !0, t.callInner.apply(this, n)
          }
        }])
      }(t),
      function(e) {
        e.extendModule("util", [{
          namespace: "canIUse",
          os: ["bwtHybrid"]
        }, {
          namespace: "scan",
          os: ["bwtHybrid"]
        }, {
          namespace: "scan",
          os: ["bwtHybrid"]
        }, {
          namespace: "albumImage",
          os: ["bwtHybrid"]
        }, {
          namespace: "cameraImage",
          os: ["bwtHybrid"]
        }, {
          namespace: "logFile",
          os: ["bwtHybrid"]
        }, {
          namespace: "setDebug",
          os: ["bwtHybrid"]
        }, {
          namespace: "setStorage",
          os: ["bwtHybrid"]
        }, {
          namespace: "getStorage",
          os: ["bwtHybrid"]
        }, {
          namespace: "removeStorage",
          os: ["bwtHybrid"]
        }, {
          namespace: "clearStorage",
          os: ["bwtHybrid"]
        }, {
          namespace: "openSetting",
          os: ["bwtHybrid"]
        }, {
          namespace: "share",
          os: ["bwtHybrid"]
        }, {
          namespace: "killApplePay",
          os: ["bwtHybrid"]
        }, {
          namespace: "reviveApplePay",
          os: ["bwtHybrid"]
        }, {
          namespace: "setLocalNotification",
          os: ["bwtHybrid"]
        }, {
          namespace: "cancelLocalNotification",
          os: ["bwtHybrid"]
        }, {
          namespace: "setCalendar",
          os: ["bwtHybrid"]
        }, {
          namespace: "cancelCalendar",
          os: ["bwtHybrid"]
        }, {
          namespace: "openLongPressQRCode",
          os: ["bwtHybrid"]
        }, {
          namespace: "cancelLongPressQRCode",
          os: ["bwtHybrid"]
        }, {
          namespace: "getTodayStepCounter",
          os: ["bwtHybrid"]
        }, {
          namespace: "sign",
          os: ["bwtHybrid"]
        }, {
          namespace: "verifySign",
          os: ["bwtHybrid"]
        }, {
          namespace: "getCashierConfig",
          os: ["bwtHybrid"]
        }])
      }(t),
      function(e) {
        e.extendModule("user", [{
          namespace: "getToken",
          os: ["bwtHybrid"]
        }, {
          namespace: "isLogin",
          os: ["bwtHybrid"]
        }, {
          namespace: "getUserInfo",
          os: ["bwtHybrid"]
        }])
      }(t)
    }(_), _.version = "2.0.0";
    t.default = _
  }]).default
}));



//////////////////
// WEBPACK FOOTER
// ./static/bwtHybrid.min.js
// module id = Dv7I
// module chunks = 20